import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

const Layout = ({ children }) => {
  return (
    <div className="container-fluid min-vh-100 d-flex flex-column bg-white">
      {/* Sticky Navigation Buttons */}
      {/* <div
        className={`d-flex ${isMobile ? "flex-column align-items-center" : "justify-content-center"} py-3`} 
        style={{ gap: "10px", position: "sticky", top: "0", zIndex: "1000", backgroundColor: "#fff" }}
      >
        <Link to="/profile" className={`d-flex justify-content-center ${isMobile ? "w-50" : "w-25"}`} style={{ textDecoration: "none" }}>
          <button className="btn w-100" style={getButtonStyle("/profile")}>
            <i className="bi bi-person-circle me-2"></i> Profile
          </button>
        </Link>
        
        <Link to="/manage-subscription" className={`d-flex justify-content-center ${isMobile ? "w-50" : "w-25"}`} style={{ textDecoration: "none" }}>
          <button className="btn w-100" style={getButtonStyle("/manage-subscription")}>
            <i className="bi bi-box-seam me-2"></i> Subscriptions
          </button>
        </Link>
      </div> */}

      {/* Main Content */}
      <div className="p-1">{children}</div>

    </div>
  );
};

export default Layout;
